export interface InboxStageTagProps {
  name: string;
}

/**
 * A compact, neutral chip showing an opportunity's pipeline stage on an inbox
 * row. Reads as a quiet status marker, distinct from the plain-text metadata
 * tags beside it without relying on colour.
 * @param name - The stage's display name (e.g. "Intake", "Quote In Progress")
 * @returns The rendered stage tag
 */
export function InboxStageTag({ name }: InboxStageTagProps) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-red-500/25 bg-red-500/10 px-2 py-0.5 text-[10px] font-medium leading-none text-red-600 dark:text-red-400">
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-red-500" />
      {name}
    </span>
  );
}
